module.exports = __webpack_public_path__ + "assets/img/logo4.27520562.png";